import React, { ReactElement, useState } from 'react';
import { Popover } from 'antd';

import SvgIcon from '~src/shared/SvgIcon';
import Dialog from '~src/shared/dialogs/dialog/Dialog';
import { KeyTextObj } from '~src/interfaces/translation.interface';

import { Toggle, EmptyMessage, ToggleBoxContainer } from './toggleBox.sc';

interface ModalTexts {
  header: KeyTextObj;
  title: KeyTextObj;
  subtitle: KeyTextObj;
  submit: KeyTextObj;
  cancel: KeyTextObj;
}

interface DefaultProps {
  size?: 'big' | 'small';
  // modalHeader: string;
  title?: string[];
  active: boolean;
  locked?: boolean;
  showModalOnChange?: boolean;
  popoverMessage?: KeyTextObj | null;
  modalTexts?: ModalTexts;
  onChangeBox(toggled: boolean): void;
  renderModelBody?: (onSubmit: () => void, onCancel: () => void, modalTexts: ModalTexts) => JSX.Element;
}

const ToggleBox: React.FC<DefaultProps> = ({
  size = 'small',
  title = ['YES', 'NO'],
  active = true,
  locked = false,
  showModalOnChange = false,
  popoverMessage = null,
  modalTexts,
  onChangeBox,
  renderModelBody,
}) => {
  const [toggled, setToggled] = useState(active);
  const [showModal, setShowModal] = useState(false);

  const changeToggle = () => {
    onChangeBox(!toggled);
    setToggled((toggled) => !toggled);
  };

  const checkToggle = () => {
    if (!locked) {
      if (showModalOnChange && !toggled) {
        setShowModal(true);
      } else {
        changeToggle();
      }
    }
  };

  const submitModal = () => {
    setShowModal(false);
    changeToggle();
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const renderWithPopover = (content: ReactElement, message: KeyTextObj) => (
    <Popover content={<div style={{ maxWidth: 200 }}>{message.txt}</div>} trigger="hover" placement="bottom">
      {content}
    </Popover>
  );

  const messageContainer = (
    <EmptyMessage>{!locked ? title[1] : <SvgIcon name="iconSimpleLock" width={15} />}</EmptyMessage>
  );

  return (
    <div>
      {showModalOnChange && (
        <Dialog
          show={showModal}
          headerColor="baseBlue"
          title={modalTexts && modalTexts?.header.txt}
          onHide={closeModal}
        >
          {renderModelBody && modalTexts && renderModelBody(submitModal, closeModal, modalTexts)}
        </Dialog>
      )}
      <ToggleBoxContainer $size={size} onClick={checkToggle} role="switch">
        {locked && popoverMessage ? renderWithPopover(messageContainer, popoverMessage) : messageContainer}
        <EmptyMessage>{!locked ? title[0] : <SvgIcon name="iconSimpleLock" width={15} />}</EmptyMessage>
        <Toggle $size={size} $active={toggled}>
          {title[toggled ? 0 : 1]}
        </Toggle>
      </ToggleBoxContainer>
    </div>
  );
};

export default ToggleBox;
